import { HttpClient, RequestParams } from "@/utils/http-client";

export enum ProductTypeValueType {
  Course = "course",
  Marathon = "marathon",
  Lesson = "lesson",
  Astrology = "astrology",
  AstrologyBundle = "astrology_bundle",
  MarathonBundle = "marathon_bundle",
  Bundle = "bundle",
  Resource = "resource",
  EventTicket = "event_ticket",
  EventDoubleTicket = "event_double_ticket",
  EventBooking = "event_booking",
  EventDoubleBooking = "event_double_booking",
  Webinar = "webinar",
  Media = "media",
}

export interface ProductListParamsType {
  /** title substring search */
  title?: string;
  /** subtitle substring search */
  subtitle?: string;
  /** ProductType enum */
  type?: ProductTypeValueType;
  course_id?: number;
  owner_id?: number;
  parent_id?: number;
  category_id?: number;
  /** return only products for specific plan */
  plan_id?: number;
  /** free flag on products (ignore for all) */
  free?: boolean;
  limit?: number;
  offset?: number;
}

export enum PlanCurrencyType {
  Usd = "usd",
  Eur = "eur",
  Rub = "rub",
}

export enum PlanTypeType {
  Media = "media",
  Products = "products",
}

export interface PlanType {
  /** @format date-time */
  created_at?: string;
  /** @format int64 */
  creator_id?: number;
  currency?: PlanCurrencyType;
  description?: string;
  /** @format int64 */
  discount_price_annual?: number;
  /** @format int64 */
  discount_price_monthly?: number;
  /** @format int64 */
  id?: number;
  /** @format date-time */
  modified_at?: string;
  /** @format int64 */
  price_annual_eur?: number;
  /** @format int64 */
  price_monthly_eur?: number;
  /** @format int64 */
  price_annual_rub?: number;
  /** @format int64 */
  price_monthly_rub?: number;
  title?: string;
  type?: PlanTypeType;
}

export enum PlanTypeValueType {
  Media = "media",
  Products = "products",
}

export interface PlanListParamsType {
  type?: PlanTypeValueType;
  limit?: number;
  offset?: number;
}

export class Plans<
  SecurityDataType = unknown
> extends HttpClient<SecurityDataType> {
  /**
   * @description Returns plans list by filter, with limit/offset pagination, and total count in header
   *
   * @tags plans
   * @name PlanList
   * @summary Get list of plans by filter
   * @request GET:/plans
   * @secure
   * @response `200` `(PlanType)[]` Plan object
   * @response `500` `void` error
   */
  planList = (query: PlanListParamsType, params: RequestParams = {}) =>
    this.request<PlanType[], void>({
      path: `/plans`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
}
